module.exports = __webpack_public_path__ + "img/VECTOLABS.344bf8c4.png";